import React, { useState } from "react";
import TemplateCard from "./TemplatesCard";
import TemplateGraph from "./TemplateGraph";
import TemplateReport from "./TemplateReport";
import TemplateComparison from "./TemplateComparison";
import DashboardLayout from "../../UI/Layout/DashboardLayout";
import styles from "./Template.module.css";

const Templates = () => {
  const [selectedTemplates, setSelectedTemplates] = useState([]);
  const [showComparison, setShowComparison] = useState(false);
  const [selectedChannel, setSelectedChannel] = useState("whatsapp");

  return (
    <DashboardLayout>
      <main className="content">
        <div className="container-fluid p-0">
          <TemplateCard selectedChannel={selectedChannel} onChannelChange={setSelectedChannel} />

          {!showComparison && selectedChannel === "whatsapp" && <TemplateGraph />}

          {showComparison && (
            <TemplateComparison
              templates={selectedTemplates}
              onClose={() => setShowComparison(false)}
            />
          )}

          <TemplateReport
            selectedTemplates={selectedTemplates}
            onSelectionChange={setSelectedTemplates}
            onCompare={() => setShowComparison(true)}
            onClear={() => {
              setSelectedTemplates([]);
              setShowComparison(false);
            }}
          />
        </div>
      </main>
    </DashboardLayout>
  );
};

export default Templates;
